import ApiClient from './client';
import api from './index';
import { Logger } from '../_clean-code/utils/logger';

const middleware =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (!action[ApiClient.ACTION_KEY]) {
      next(action);
      return;
    }

    const {
      method,
      params,
      requestAction,
      successAction,
      errorAction,
      transformResponse,
      afterSuccess,
      errorHandler
    } = action;

    try {
      dispatch({ type: requestAction, payload: params, meta: { method } });

      const response = await api[method](params);

      dispatch({
        type: successAction,
        payload: transformResponse ? transformResponse(response) : response
      });
      if (afterSuccess) {
        afterSuccess(dispatch, response);
      }
    } catch (error) {
      if (errorHandler) {
        try {
          errorHandler(dispatch, error, params);
        } catch (e) {
          Logger.error(
            `middleware: Exception not controlled by middleware when calling ${method}. Error:`,
            e
          );
        }
      } else {
        dispatch({
          type: errorAction,
          error,
          payload: params
        });
      }
    }
  };

export default middleware;
